import { render } from 'preact';
import { App } from './app.js';
import { app } from './controller.js';
import './styles.css';

const root = document.getElementById('app');
if (!root) throw new Error('#app root element missing');
render(<App />, root);
void app.init();

// Offline shell. A new version installs in the background; we offer a reload rather than
// reloading by ourselves, so a half-filled form is never lost.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.register('./sw.js').catch(() => {});
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) {
      app.updateReady = true;
      void app.refresh();
    }
  });
}
